// Import necessary modules
import * as yup from "yup";
import { createValidationSchema, validate } from "@";

// Define validation schema for page details
export const schema = createValidationSchema({
  pageTitle: validate("req", "pageTitle"),
  order: validate("number", "Order"),
  showHeaderMenu: yup.boolean().default(true),
  showLowerMenu: yup.boolean().default(true),
  isActive: yup.boolean().default(true),
});

// Define validation schema for summary
export const summarySchema = createValidationSchema({
  summary: validate("req", "summary"),
});

// Define default values for the form fields
export const defaultValues = {
  order: 0,
  summary: "",
  pageTitle: "",
  isActive: true,
  externalPageUrl: "",
  showLowerMenu: true,
  showHeaderMenu: true,
};
